import type { Drone } from '@/types/mission.types'
import { Color } from 'cesium'

export const userName = 'Deevyn'
export const DEFAULT_ALTITUDE = 50.01
export const NUMERIC_KEYS = ['altitude', 'speed', 'radius', 'longitude', 'latitude']
export const drones: Drone[] = [
  {
    name: 'Mavic 3E/3T/3M',
    img: '/images/drones/drone1.png',
    enumSupport: 77,
    subEnumValue: 0,
    payloadEnumValue: 66, // Mavic 3E Camera (66-0-0), assuming 3E as primary; could be 67 (3T) or 129 (3M/3TA)
    payloadPositionIndex: 0, 
  },
  {
    name: 'Matrice 30/30T',
    img: '/images/drones/drone2.png',
    enumSupport: 67,
    subEnumValue: 0,
    payloadEnumValue: 52,
    payloadPositionIndex: 0, 
  },
  {
    name: 'Matrice 300RTK',
    img: '/images/drones/drone3.png',
    enumSupport: 60,
    subEnumValue: 0,
    payloadEnumValue: 42,
    payloadPositionIndex: 0,
  },
  {
    name: 'Matrice 350RTK',
    img: '/images/drones/drone3.png',
    enumSupport: 89,
    subEnumValue: 0,
    payloadEnumValue: 82,
    payloadPositionIndex: 0,
  },
  {
    name: 'Matrice 3D/3TD',
    img: '/images/drones/drone4.png',
    enumSupport: 91,
    subEnumValue: 0,
    payloadEnumValue: 80,
    payloadPositionIndex: 0,
  },
  {
    name: 'Matrice 4D',
    img: '/images/drones/DJI-Matrice-4D.png',
    enumSupport: 100,
    subEnumValue: 0,
    payloadEnumValue: 98,
    payloadPositionIndex: 0, 
  },
  {
    name: 'Matrice 4TD',
    img: '/images/drones/DJI-Matrice-4TD.png',
    enumSupport: 100,
    subEnumValue: 1,
    payloadEnumValue: 99,
    payloadPositionIndex: 0, 
  },
];
export const WAYPOINT_COLORS = {
  base: Color.fromCssColorString('#FCEEBF'),
  line: Color.fromCssColorString('#FAD966'),
  connection: Color.fromCssColorString('#0ADA4580'),
}

export const ACTIVE_ROUTE_COLORS = {
  base: Color.fromCssColorString('#FF9D00'),
  line: Color.fromCssColorString('#FF7A00'),
  connection: Color.fromCssColorString('#FF5A0080'),
}
export const measurementTools = ['Measure Distance', 'Measure Area', 'Measure Volume']
const selectTool = {
  icon: 'navigation',
  id: 0,
  name: 'Select',
  description: 'Select and drag elements on the map',
}

export const waypointTools = [
  selectTool,
  { icon: 'share',        id: 1, name: 'Add Waypoint',      description: 'Double click on the map to add a waypoint' },
  { icon: 'bound-circle', id: 5, name: 'Circle',            description: 'Double click to create a circle path' },
]

// Area missions: no separate Select tool; Photogrammetry (and others) support drag + add points
export const areaTools = [
  { icon: 'zig-zag',        id: 2, name: 'Photogrammetry',   description: 'Drag polygon or double-click to add points' },
  { icon: 'repeat',         id: 3, name: 'Area Scan',        description: 'Draw polygon for quick area scan' },
  { icon: 'double-circle',  id: 4, name: 'Circlegrammetry',  description: 'Set centre point for circular 3D capture' },
  { icon: 'vertical-split', id: 6, name: 'Vertical Scan',    description: 'Draw polygon for facade/vertical scan' },
]

export const corridorTools = [
  selectTool,
  { icon: 'corridor', id: 7, name: 'Corridor Mapping', description: 'Draw a path to survey a corridor' },
]

export const missionTools = [...waypointTools, ...areaTools, ...corridorTools.slice(1)]
export const otherTools = [
  {
    icon: 'edit_pen',
    id: 8,
    name: 'Make Note',
    description: 'Double click on the map to select a location and add a note',
    dependsOnRC: false,
  },
  {
    icon: 'ruler',
    id: 4,
    name: 'Measure Distance',
    description: 'Click on two points to measure the distance between them',
    dependsOnRC: false,
  },
  {
    icon: 'ruler_square',
    id: 5,
    name: 'Measure Area',
    description: 'Double click on different points to calculate the area of the polygon',
    dependsOnRC: false,
  },
  {
    icon: 'circle-ruler',
    id: 6,
    name: 'Measure Volume',
    description: 'Double click on different points to calculate the volume of the polygon',
    dependsOnRC: false,
  },
  {
    icon: 'not_allowed',
    id: 7,
    name: 'No-fly Zone: Circle',
    description: 'Double click on a point to select the center of the zone',
    dependsOnRC: true,
  },
  {
    icon: 'curved_line',
    id: 8,
    name: 'No-fly Zone: Corridor',
    description: 'Double click on different points to create a corridor, click on enter to finish',
    dependsOnRC: true,
  },
  {
    icon: 'polygon',
    id: 9,
    name: 'No-fly Zone: Polygon',
    description: 'Double click on different points to create a polygon, click on enter to finish',
    dependsOnRC: true,
  },
  {
    icon: 'geofence',
    id: 10,
    name: 'Geofence: Polygon',
    description: 'Double click on different points to create a geofence, click on enter to finish',
    dependsOnRC: true,
  },
  {
    icon: 'geofence-circle',
    id: 11,
    name: 'Geofence: Circle',
    description: 'Double click on a point to select the center of the geofence',
    dependsOnRC: true,
  },
  {
    icon: 'orbit',
    id: 12,
    name: 'Orbit Flight',
    description: 'Double click on a point to select the center of the orbit. ',
    dependsOnRC: true,
  },
]
export const zoneTools = [
  'No-fly Zone: Circle',
  'No-fly Zone: Polygon',
  'No-fly Zone: Corridor',
  'Geofence: Polygon',
  'Geofence: Circle',
]
export const routeOptions = [
  {
    name: 'Edit',
    value: 'edit',
  },
  {
    name: 'Delete',
    value: 'delete',
  },
  {
    name: 'Export',
    value: 'export',
  },
]

export const syncingActions = {
  delete: 'Deleting Mission',
  create: 'Creating Mission',
  fetch: 'Fetching Missions',
  sync: 'Syncing Missions',
  export: 'Exporting Mission',
}
